import React, { useState, CSSProperties, useEffect } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../../AbstractElements";
import { FaEdit, FaPlus } from "react-icons/fa";
import { RiPencilFill } from "react-icons/ri";
import CommonModalForNewPolicy from "./CommonModalNewPolicy/CommonModalForNewPolicy";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAddGradePolicy,
  useAddPolicyMaster,
  useDeleteGradePolicy,
  useGetGradePolicyData,
  usePolicyMasterData,
  useUpdateGradePolicy,
} from "./hooks/useGradeMaster";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

type Props = {};

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

const GradeMasterPolicy = (props: Props) => {
  // Useful Imports
  const navigate = useNavigate();
  const location = useLocation();
  const { gradeId } = location.state || {};

  // States
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [newPolicyModal, setnewPolicyModal] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [formValues, setFormValues] = useState<any>({
    gradePolicyId: "",
    policy: "",
    startdate: "",
    enddate: "",
  });
  const [selectedRowData, setSelectedRowData] = useState(null);

  // API's Hook
  const { data: gradePolicyData,isLoading,isSuccess } = useGetGradePolicyData({
    enable: true,
    params: { gradeId: Number(gradeId) },
  });
  const { data: policyMasterData } = usePolicyMasterData({ enable: true });
  const { mutate } = useAddGradePolicy();
  const { mutate: updateGradePolicy } = useUpdateGradePolicy();
  const { mutate: newPolicyAdd } = useAddPolicyMaster();
  const { mutate: deleteGradePolicy } = useDeleteGradePolicy({
    params: { gradePolicyId: formValues?.gradePolicyId },
  });

  // Formatted Data for Policy Dropdown
  let formattedPolicyData = policyMasterData?.data.map(
    (item: any, index: any) => ({
      id: item?.PolicyId,
      label: item?.PolicyName.trim(),
    })
  );

  // FormattedData for the Grade Policy Data for the Table
  let formattedGradePolicyData = gradePolicyData?.data.map(
    (item: any, index: any) => ({
      ...item,
      Sr: index + 1,
    })
  );

  // Function for navigation to policy master
  const NavigateToPolicyMaster = () => {
    navigate("/configuration/grademaster/policymaster");
  };

  // Function for new link policy
  const handleLinkNewPolicyPoliciesTableButton = () => {
    console.log("handleLinkNewPolicyPoliciesTableButton");
    setIsModelOpen(!isModelOpen);
    setModalStatus("Existing");
  };

  // Toggle modal
  const togglenewPolicy = () => {
    setnewPolicyModal((prev) => !prev);
    setModalStatus("");
    setFormValues("");
  };

  // Handle Cancel button
  const handleCancilBtn = () => {
    setnewPolicyModal(false);
    setModalStatus("");
  };

  //Submit Form  Function New Policy
  const handlenewPolicyForm = (formData: any) => {
    if (modalStatus === "New Policy") {
      const newPolicyBody = {
        policyName: formData?.name,
        policyCode: formData?.shortcode,
        currencyId: formData?.currency,
        orgUnitId: formData?.orgunit,
        startDate: formData?.startdate,
        endDate: formData?.enddate,
      };

      newPolicyAdd(newPolicyBody, {
        onSuccess: () => {
          togglenewPolicy(); // Close the modal after submission
          setFormValues("");
          setModalStatus("");
          // navigate("/configuration/grademaster/policymaster");
        },
        onSettled: () => {
          togglenewPolicy(); // Close the modal after submission
          setFormValues("");
          setModalStatus("");
          // navigate("/configuration/grademaster/policymaster");
        },
      });
    }
  };

  // Function for Edit Policy Request
  const handlePoliciesRequestEdit = (row: any) => {
    setFormValues({
      gradePolicyId: row?.GradePolicyId,
      policy: row?.PolicyId,
      startdate: row?.StartDate,
      enddate: row?.EndDate,
    });
    setIsModelOpen(true);
    setModalStatus("Edit");
    setSelectedRowData(row);
  };

  // Function New Policy
  const handleNewPoliciesTableButton = () => {
    setnewPolicyModal(true);
    setModalStatus("New Policy");
  };

  const handleSubmitFormAddGrade = (formData: any) => {
    if (modalStatus === "Existing") {
      const addBody = {
        gradeId: Number(gradeId),
        policyId: Number(formData?.policy),
        startDate: formData?.startdate,
        endDate: formData?.enddate,
      };

      mutate(addBody, {
        onSuccess: () => {
          // handleCancilBtn();
          setIsModelOpen(false);
          setFormValues("");
          // setSelectedRowData(null);
        },
      });
    } else {
      const updateBody = {
        gradePolicyId: Number(formValues?.gradePolicyId),
        gradeId: Number(gradeId),
        policyId: Number(formData?.policy),
        startDate: formData?.startdate,
        endDate: formData?.enddate,
      };

      updateGradePolicy(updateBody, {
        onSuccess: () => {
          setIsModelOpen(false);
          setFormValues("");
        },
      });
    }
  };

  const handleDeletePolicy = () => {
    console.log(
      "{ gradePolicyId: formValues?.gradePolicyId }",
      formValues?.gradePolicyId
    );
    deleteGradePolicy();
    setIsModelOpen(false);
    // setFormValues("");
  };

  // Handle dropdown selection
  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  // Handle input changes
  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["a", "b"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "") // Allow only numbers
      : value; // Keep string values as they are

    setFormValues((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  return (
    <div className="p-2">
      <div className="col-md-12">
        <PageHeader
          title="Grade Master"
          buttons={[
            {
              label: "Policy Master",
              onClick: NavigateToPolicyMaster,
              color: "#43B9B2",
            },
          ]}
        />
        <BasicDataTable
          Title="Policies"
          showSpinner={isLoading}
          data={formattedGradePolicyData || []}
          columns={PoliciesDataDataColumns(handlePoliciesRequestEdit)}
          headerContent={
            <div className="row g-3 justify-content-center">
              <div className="col-12 col-md-5 d-flex justify-content-md-end justify-content-center">
                <TableButton
                  onClick={handleLinkNewPolicyPoliciesTableButton}
                  title="Existing"
                  style={{
                    backgroundColor: "#44bcb4",
                    width: "110%",
                    border: "none",
                  }}
                />
              </div>

              <div className="col-12 col-md-7 d-flex justify-content-md-start justify-content-center">
                <TableButton
                  onClick={handleNewPoliciesTableButton}
                  title="New Policy"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          }
        />
      </div>
      <RouteModal
        size="md"
        isOpen={isModelOpen}
        toggle={() => {
          setIsModelOpen(!isModelOpen);
          setFormValues("");
        }}
        title={modalStatus === "Edit" ? "Edit Policy" : "Existing"}
        content={
          <div>
            <div className="row mb-0">
              <div className="col-md-12">
                <ReusableDropdown
                  options={formattedPolicyData || []}
                  value={formValues.policy}
                  onChange={(value: any) => {
                    handleDropdownSelect("policy", value);
                  }}
                  DropdownHeading="Policy"
                />
              </div>
              <div className="row mb-0">
                <div className="col-md-6">
                  <CustomInput
                    type="date"
                    label="Start Date"
                    placeholder="Enter Start Date"
                    name="startdate"
                    value={formValues.startdate}
                    onChange={(e) => handleInputChange("startdate", e)}
                    // disabled={modalStatus === "View"}
                    style={{ borderRadius: "4px" }}
                  />
                </div>
                <div className="col-md-6">
                  <CustomInput
                    type="date"
                    label="End Date"
                    placeholder="Enter End Date"
                    name="enddate"
                    value={formValues.enddate}
                    onChange={(e) => handleInputChange("enddate", e)}
                    style={{ borderRadius: "4px" }}
                  />
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-start gap-2 mt-4 ">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                onClick={() => handleSubmitFormAddGrade(formValues)}
              >
                {modalStatus === "Edit" ? "Update" : "Submit"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  borderColor: "#d4d4d4",
                }}
                type="button"
                onClick={() => {
                  console.log("Cancel setIsGradeModelOpen ");
                  setIsModelOpen(false);
                  // setEditModel(false);
                  setFormValues("");
                }}
              >
                {" "}
                Cancel
              </Btn>
              <Btn
                style={{ backgroundColor: "#d35400", color: "white" }}
                type="submit"
                onClick={handleDeletePolicy}
              >
                Delete {/* {modalStatus === "Edit" ? "Update" : "Submit"} */}
              </Btn>
            </div>
          </div>
        }
      />

      <CommonModalForNewPolicy
        title="Add Policy"
        isModalOpen={newPolicyModal}
        handleSubmit={handlenewPolicyForm}
        toggleModal={togglenewPolicy}
        onCancilBtn={handleCancilBtn}
        modalContentState={modalStatus}
        selectedRowData={selectedRowData}
      />
    </div>
  );
};

export default GradeMasterPolicy;
const TableButton: React.FC<TableButtonProps> = ({
  onClick,
  title = "Add Heads",
  style,
}) => {
  const defaultStyle: CSSProperties = {
    display: "flex",
    borderRadius: "20px",
    padding: "2px",
    width: "110px",
    height: "40px",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  };

  return (
    <div>
      <button
        onClick={onClick}
        className="btn btn-info"
        style={{ ...defaultStyle, ...style }} // External styles override default
      >
        <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
      </button>
    </div>
  );
};

const PoliciesDataDataColumns = (
  handlePoliciesRequestEdit: (row: any) => void
) => [
  {
    name: "Sr.",
    selector: (row: { Sr: number | string }) => row.Sr,
    maxWidth: "10%",
  },
  {
    name: "Name",
    selector: (row: { PolicyName: string }) => row.PolicyName,
  },
  {
    name: "Code",
    selector: (row: { PolicyCode: string }) => row.PolicyCode,
  },
  {
    name: "Start Date",
    selector: (row: { StartDate: string }) => row.StartDate,
  },
  {
    name: "End Date",
    selector: (row: { EndDate: string }) => row.EndDate,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handlePoliciesRequestEdit(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];
